"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const SpinnerSVG_1 = require("./assets/SpinnerSVG");
const Spinner = ({ spinner, spinnerColor }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
            position: 'fixed',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            width: '100%',
            height: '100%',
            outline: '0',
            zIndex: 10001,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0)',
        } }, { children: spinner ? spinner : spinner !== false && (0, jsx_runtime_1.jsx)(SpinnerSVG_1.default, { spinnerColor: spinnerColor }) })));
};
exports.default = Spinner;
